module.exports = __webpack_public_path__ + "media/images/lp/industries/img-wave01-7d4fdd4bff43581f8139842d252261fd.svg";